import React, { useState } from 'react'
import { getInstallerDownloadUrl } from '../../services/companionService'
import { backendService } from '../../services/backendService'

const DOWNLOAD_URL = getInstallerDownloadUrl(backendService.getBaseURL(), 'exe')

export const ToolboxStatus: React.FC = () => {
  const [showPanel, setShowPanel] = useState(false)

  return (
    <div className="toolbox-status-wrapper">
      <span
        className="toolbox-badge not-paired"
        onClick={() => setShowPanel(v => !v)}
        title="Download Girasoles Toolbox"
      >
        Girasoles Toolbox
      </span>

      {showPanel && (
        <div className="toolbox-panel">
          <p><strong>Girasoles Toolbox v0.2.4</strong></p>
          <p>
            Offline desktop app for Windows. Export your slicer presets as a zip bundle
            and share it via this chat — no server connection required.
          </p>
          <a
            href={DOWNLOAD_URL}
            target="_blank"
            rel="noopener noreferrer"
            className="toolbox-download-btn"
          >
            Download GirasolToolbox.exe
          </a>
          <button className="toolbox-close-btn" onClick={() => setShowPanel(false)}>Close</button>
        </div>
      )}
    </div>
  )
}

export default ToolboxStatus

